import { render, staticRenderFns } from "./shopStoreTable.vue?vue&type=template&id=2dae8a58&"
import script from "./shopStoreTable.vue?vue&type=script&lang=js&"
export * from "./shopStoreTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports